import styled from 'styled-components';

export const CheckboxWrap = styled.div`
  height: 100%;
  border-top: 2px solid #fff;
  padding-top: 2px;

  tr:first-child & {
    border-top-color: transparent;
  }
`;

export const TableUsername = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  padding-left: 80px;

  font-family: Cairo;
  letter-spacing: 0.3px;
  color: rgba(0, 0, 0, 0.87);
  transition: 0.25s all;

  &:hover {
    color: #00bbf4;
    tex
  }
`;

export const TableAvatar = styled.div`
  width: 80px;
  height: calc(100% + 3px);
  display: flex;
  align-items: center;
  justify-content: center;

  position: absolute;
  top: -1px;
  left: 0;

  border-top: 2px solid #fff;
  border-bottom: 2px solid #fff;

  img {
    margin-top: -3px;
  }

  tr:first-child & {
    border-top-color: transparent;
  }
`;



// WEBPACK FOOTER //
// ./src/components/IterioApp/Users/UserTableCell/UserTableCell.styles.js